import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { isSectionActive } from './side-bar.matchers';
import { ChildSidebarLink } from './side-bar-link';
import type { SidebarSectionEntry } from './types';

type SidebarSectionProps = {
  isOpen: boolean;
  onNavigate?: () => void;
  onToggle: () => void;
  pathname: string;
  section: SidebarSectionEntry;
};

export function SidebarSection({
  isOpen,
  onNavigate,
  onToggle,
  pathname,
  section,
}: SidebarSectionProps) {
  const Icon = section.icon;
  const hasActiveItem = isSectionActive(section, pathname);

  return (
    <>
      <li
        aria-expanded={isOpen}
        className={`row ${hasActiveItem ? 'active' : ''}`}
        onClick={onToggle}
      >
        <div id='icon'>
          <Icon />
        </div>
        <p id='title'>{section.label}</p>
        <div id='icon2'>
          <ExpandMoreIcon />
        </div>
      </li>
      <div className={`dropdown ${isOpen ? 'open' : ''}`}>
        <div className='dropdown-item'>
          <ul className='SidebarListInternal'>
            {section.items.map((item) => (
              <ChildSidebarLink
                item={item}
                key={item.id}
                onNavigate={onNavigate}
                pathname={pathname}
              />
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
